import React from "react";
import { Container, Col, Row } from "reactstrap";
import { Fields } from "@repoflow/components/fields";
import { useSectionContext } from "@repoflow/components/section";
import { Link } from "react-router-dom";
import * as widgets from "widgets/register";
import { DOCUMENTS } from "@common/schema/site-file/kind";

// Hoisted for the reason recorded in ../edit: a config literal is a new object
// every render and the provider rebuilds underneath it.
//
// The whole row, because the whole row is five short fields and every one of
// them is something a person came here to check — which prefix, which
// directory rule, which archive, and whether it is actually mounted.
const VIEW_FIELDS = {
  "/Public/SitePack": {
    fields: ["packId", "route", "type", "fileId", "status", "createdAt", "updatedAt"],
  },
};

export const Sidebar = () => null;

export const Indice = () => null;

// The mount, and the two things you can do to it.
//
// NO PREVIEW PANE, unlike a section's. A pack's bytes are not composed by this
// service — they are served from bucketws under the site's own verified
// hostname, on an origin this app deliberately is not (P142) — so there is
// nothing here that could render it honestly. A frame pointed at the app's own
// origin would show an attachment download rather than the bundle, which is a
// worse answer than no frame at all.
export const Content = ({
  match: {
    params: { siteId },
  },
}) => {
  const { values, schema, base } = useSectionContext();

  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <div className="float-right">
            <Link className="btn btn-primary" to={`${base}/edit`}>
              Edit
            </Link>{" "}
            <Link className="btn btn-danger" to={`${base}/remove`}>
              Remove
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Fields
            schema={schema}
            values={values}
            widgets={widgets}
            target={{ $ref: "/Public/SitePack" }}
            config={VIEW_FIELDS}
          />
        </Col>
      </Row>
      {/* The way to the archive itself, offered only when there is one. Its
          size, its status and whether bucketws has finished extracting it are
          all on the file's own screen, and none of them are on this row. */}
      {values.fileId && (
        <Row className="mt-3">
          <Col>
            {/* Built from `siteId` rather than by walking the context's
                `parent` chain: the depth of that chain is a property of how
                these routes happen to nest, and the Files URL is not. Same
                shape components/file-selector uses for its "Upload one"
                link. */}
            <Link to={`/site/${siteId}/file/${DOCUMENTS}/${values.fileId}/`}>
              Open the archive in Documents
            </Link>
          </Col>
        </Row>
      )}
    </Container>
  );
};
